module.exports = __webpack_public_path__ + "ubisoft-plus_hero_desktop.jpg";